<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div class="courseStudents" v-else>
      <b-overlay :show="loadData" spinner-variant="primary" spinner-type="grow" spinner-small rounded="md">
        <b-button class="mb-2" variant="primary" size="sm" @click="addStudent = !addStudent"
          v-if="!addStudent && studentsToDelete.length == 0" pill>Add</b-button>
        <div class="addCourseStudents" :courseStudentModal="courseStudentModal" v-if="addStudent">
          <AddStudents :courseStudentModal="courseStudentModal" @addStudentStatus="addStudentStatus"
            :courseStudentsList="courseStudentsList" />
        </div>

        <div v-else>
          <div class="submitBtn mb-2 d-flex justify-content-between" v-if="studentsToDelete.length != 0">
            <b-button variant="danger" size="sm" :disabled="submitBtn.disabled" @click="openDeleteModal()">{{
                submitBtn.text
            }}</b-button>
          </div>
          <div class="mb-2">
            <span>
              Student should firstly added to the class before being able to enroll them to courses
            </span>
          </div>
          <table class="table table-striped table-bordered">
            <thead class="thead-dark text-left">
              <tr>
                <th></th>
                <th>{{ studentListOrder === 'enrollment_no' ? 'Enrollment No.' : studentListOrder === 'admission_number' ? 'Admission No.' : studentListOrder === 'register_number' ? 'Register No.' : 'Roll No.' }}</th>
                <th>Name</th>
                <th v-if="viewStudentSubgroups">{{subgroupCustomName}}</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Guardian Mobile.</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(student, studentIndex) in courseStudentsList" :key="studentIndex">
                <td class="align-middle">
                  <b-form-checkbox v-model="studentsToDelete" :value="student.id">
                  </b-form-checkbox>
                </td>
                <td class="align-middle">
                  {{ studentListOrder === 'enrollment_no' ? (student.enrollment_no || '-') : studentListOrder === 'admission_number' ? (student.admission_no || '-') : studentListOrder === 'register_number' ? (student.register_no || '-') : (student.roll_number || 'RN') }}
                </td>
                <td>
                  {{ student.first_name || " " }} {{ student.last_name || " " }}
                </td>
                <td v-if="viewStudentSubgroups">{{ student.usersubgroup ? student.usersubgroup : '' }}</td>
                <td class="align-middle">{{ student.email }}</td>
                <td class="align-middle">{{ student.mobile }}</td>
                <td class="align-middle">{{ student.guardianNumber }}</td>
              </tr>
            </tbody>
          </table>

          <h6 class="mt-3">Removed Students ({{ removedStudentsList.length }})</h6>
          <table class="table table-striped table-bordered">
            <thead class="thead-dark text-left">
              <tr>
                <th>{{ studentListOrder === 'enrollment_no' ? 'Enrollment No.' : studentListOrder === 'admission_number' ? 'Admission No.' : studentListOrder === 'register_number' ? 'Register No.' : 'Roll No.' }}</th>
                <th>Name</th>
                <th v-if="viewStudentSubgroups">{{subgroupCustomName}}</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Guardian Mobile.</th>
                <th>Restore</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="removedStudentsList.length === 0">
                <td colspan="7" class="text-center text-muted">No removed students</td>
              </tr>
              <tr v-else v-for="(student, studentIndex) in removedStudentsList" :key="'removed' + studentIndex">
                <td class="align-middle">
                  {{ studentListOrder === 'enrollment_no' ? (student.enrollment_no || '-') : studentListOrder === 'admission_number' ? (student.admission_no || '-') : studentListOrder === 'register_number' ? (student.register_no || '-') : (student.roll_number || 'RN') }}
                </td>
                <td>
                  {{ student.first_name || " " }} {{ student.last_name || " " }}
                </td>
                <td v-if="viewStudentSubgroups">{{ student.usersubgroup ? student.usersubgroup : '' }}</td>
                <td class="align-middle">{{ student.email }}</td>
                <td class="align-middle">{{ student.mobile }}</td>
                <td class="align-middle">{{ student.guardian_mobile }}</td>
                <td class="align-middle">
                  <b-button variant="primary" size="sm" @click="restoreStudent(student)">Restore</b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-overlay>
    </div>

    <b-modal title="Remove Students" v-model="showDeleteModal" centered>
      <p class="text-danger">
        You are going to remove {{ studentsToDelete.length }} student(s) from this course. Their data in this course
        (eg: attendance, marks, course grouping, activity answers, survey responses, university exam scores, lab
        evaluation scores) will be hidden. You can restore them later from 'Removed Students'.
      </p>
      <p>To confirm, type <strong>DELETE</strong> and click Delete.</p>
      <b-form-input v-model="deleteInput" placeholder="Type DELETE to confirm" class="mt-2"></b-form-input>
      <template #modal-footer>
        <b-button variant="secondary" size="sm" @click="showDeleteModal = false">Cancel</b-button>
        <b-button variant="danger" size="sm" :disabled="deleteInput !== 'DELETE'" @click="confirmStudentsDeletion()">
          Delete
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import AddStudents from "./AddStudents.vue";
export default {
  props: ["courseStudentModal"],
  async created() {
    this.subgroupCustomName = this.$store.getters.getCustomNamings.userSubgroup.custom_name ?? "Usersubgroup";
    this.fetchData = true;
    await this.getCourseStudents();
    this.fetchData = false;
  },
  components: {
    AddStudents,
  },
  data() {
    return {
      subgroupCustomName:'',
      fetchData: false,
      loadData: false,
      viewStudentSubgroups: false,
      courseStudentsList: [],
      removedStudentsList: [],
      studentListOrder: 'roll_number',
      studentsToDelete: [],
      showDeleteModal: false,
      deleteInput: '',
      addStudent: false,
      submitBtn: {
        text: "Delete",
        diabled: false,
      },
    };
  },
  methods: {
    openDeleteModal() {
      this.deleteInput = '';
      this.showDeleteModal = true;
    },
    async confirmStudentsDeletion() {
      if (this.deleteInput !== 'DELETE') return;
      this.showDeleteModal = false;
      this.deleteInput = '';
      await this.prepareStudentsDeletion();
    },
    async prepareStudentsDeletion() {
      this.loadData = await true;
      this.submitBtn = await {
        text: "Please wait...",
        diabled: true,
      };

      for (let user in this.studentsToDelete) {
      
        let url = `${this.$store.getters.getAPIKey.mainAPI}/courseusers/deletestudent/${this.studentsToDelete[user]}`;
        await this.$axios
          .delete(url)
          .then(() => {
            if (user == this.studentsToDelete.length - 1) {
              this.$toast.success("Users Deleted!", {
                position: "top",
                duration: 3000,
              });

              this.$emit("studentsRemoved", true);
            }
          })
          .catch(() => {
            this.$toast.error("Something went wrong, Please try again!", {
              position: "top",
              duration: 3000,
            });
          });
      }
      await this.getCourseStudents();
      this.loadData = false;
      this.submitBtn = {
        text: "Delete",
        diabled: false,
      };
    },
    async getCourseStudents() {
      this.fetchData = true;
      this.studentsToDelete = [];
      let mainUrl = this.$store.getters.getAPIKey.createStudent;
      const url = mainUrl.replace("course_id", this.courseStudentModal.id) + '?sortBy=student_list_order';
      await this.$axios
        .get(url)
        .then((response) => {
          this.courseStudentsList = [];
          this.courseStudentsList = response.data.users ?? response.data[0];
          this.studentListOrder = response.data.student_list_order || 'roll_number';
          this.courseStudentsList.forEach(stud => {
            if (stud.usersubgroup != null) this.viewStudentSubgroups = true;
          });
          // this.courseStudentsList.sort(function(a, b) {
          //   return (
          //     a.roll_number - b.roll_number ||
          //     a.first_name.localeCompare(b.first_name)
          //   );
          // });
          response;
          this.fetchData = false;
        })
        .catch(() => {
          // console.log(error.response);
          this.fetchData = false;
        });
      await this.getRemovedStudents();
    },
    async getRemovedStudents() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/course/${this.courseStudentModal.id}/removedstudents`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.removedStudentsList = response.data;
        })
        .catch(() => {
          this.removedStudentsList = [];
        });
    },
    async restoreStudent(student) {
      const name = `${student.first_name || ""} ${student.last_name || ""}`.trim();
      if (!confirm(`Restore ${name}? Their attendance, marks and other data in this course will be restored too.`)) return;

      this.loadData = true;
      const url = `${this.$store.getters.getAPIKey.mainAPI}/courseusers/addremoveduser?courseuser_id=${student.id}`;
      await this.$axios
        .post(url)
        .then(() => {
          this.$toast.success(`${name} restored`, {
            position: "top",
            duration: 3000,
          });
          this.$emit("newStudentAdded");
        })
        .catch(() => {
          this.$toast.error("Something went wrong, Please try again!", {
            position: "top",
            duration: 3000,
          });
        });
      await this.getCourseStudents();
      this.loadData = false;
    },
    addStudentStatus(status) {
      if (status) {
        this.addStudent = !this.addStudent;
        this.$emit("newStudentAdded");
      } else {
        this.addStudent = !this.addStudent;
      }
    },
  },
};
</script>
